module.exports = __webpack_public_path__ + "static/media/uy.c1ff1979.svg";